var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"cb8a6d0429e3fd0606cb0d93a7138bbd5e9c0db1"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["app@coordinape"]={id:"cb8a6d0429e3fd0606cb0d93a7138bbd5e9c0db1"};
      